<template>
  <li
    v-if="canViewHorizontalNavMenuLink(item)"
    class="main-menu-item"
    :class="{
      'main-menu-item--active': isActive,
      'main-menu-item--disabled': item.disabled,
    }"
    draggable="true"
    @dragstart="onDragStart(item)"
    @dragend="onDragEnd"
  >
    <router-link
      v-if="linkProps.to"
      v-bind="linkProps"
      class="main-menu-item__link"
      @click.native="$emit('navigate')"
    >
      <span class="main-menu-item__text">{{ $tc(item.title, 2) }}</span>
    </router-link>
    <a
      v-else
      :href="linkProps.href"
      :target="linkProps.target"
      :rel="linkProps.rel"
      class="main-menu-item__link"
      @click="$emit('navigate')"
    >
      <span class="main-menu-item__text">{{ $tc(item.title, 2) }}</span>
    </a>
  </li>
</template>

<script>
import { computed } from '@vue/composition-api'
import { isNavLinkActive, navLinkProps } from '@core/layouts/utils'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { SLOT_TYPES, SOURCES } from '@/config/layoutConfig'
import store from '@/store'

export default {
  name: 'MainMenuItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { canViewHorizontalNavMenuLink } = useAclUtils()

    const isActive = computed(() => isNavLinkActive(props.item))

    const linkPropsComputed = navLinkProps(props.item)
    const linkProps = computed(() => linkPropsComputed.value)

    // Drag support
    const draggableMenus = [
      'dmp_alarms',
      'dmp_logs',
      'dmp_panels',
      'dmp_profiles',
      'unit',
      'OperationalSecurityFormAnswers',
      'omnicloud_watchlist',
      'omnicloud_face_recognition',
      'alarm',
      'detection_event',
      'crisis_form',
      'operational_processes',
      'user-shifts',
      'external_personnel_access_control',
      'hanwha_logs',
    ]

    const onDragEnd = () => {
      store.dispatch('grid/resetSlotSelection')
    }

    const onDragStart = (data) => {
      const { route } = data
      if (draggableMenus.includes(route)) {
        let routeParsed = route == "OperationalSecurityFormAnswers" ? "operational_processes" : route;
        store.dispatch('grid/setSlotData', {
          type: SLOT_TYPES.DRAGGABLE_MENU,
          name: 'Draggable menu',
          data: {
            showFilters: false,
            type: routeParsed,
          },
          source: SOURCES.MAIN_SEARCH,
        })
      }
    }

    return {
      isActive,
      linkProps,
      canViewHorizontalNavMenuLink,
      onDragStart,
      onDragEnd,
    }
  },
}
</script>

<style scoped>

.main-menu-item {
  list-style: none;
}

.main-menu-item__link {
  display: flex;
  align-items: center;
  padding: 0.55rem 1.25rem;
  color: #625f6e;
  text-decoration: none;
  font-size: 0.95rem;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.main-menu-item__link:hover {
  background-color: rgba(27, 61, 94, 0.12);
  color: var(--primary);
}

.main-menu-item--active > .main-menu-item__link {
  color: var(--primary);
  background-color: rgba(27, 61, 94, 0.12);
}

.main-menu-item--disabled {
  pointer-events: none;
  opacity: 0.5;
}

.main-menu-item__text {
  text-transform: capitalize;
}
.dark-layout .main-menu-item__link {
  color: #d0d2d6;
}

.dark-layout .main-menu-item__link:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark-layout .main-menu-item--active > .main-menu-item__link {
  background-color: rgba(255, 255, 255, 0.08);
}
</style>
